var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menu-class" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "menu-icon", on: { click: _vm.hideMenu } }, [
        _c("img", { attrs: { src: _vm.closeImg } }),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            {
              staticClass: "item",
              on: {
                click: function ($event) {
                  return _vm.toMenu("-1")
                },
              },
            },
            [
              _vm.language === "zh"
                ? _c("span", [_vm._v("首页")])
                : _vm.language === "en"
                ? _c("span", [_vm._v("Home")])
                : _vm._e(),
            ]
          ),
          _vm._l(_vm.menuData, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "item",
                class: _vm.menuActiveIndex == index ? "active" : "",
                on: {
                  click: function ($event) {
                    return _vm.toMenu(index)
                  },
                },
              },
              [_vm._v("\n\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t")]
            )
          }),
        ],
        2
      ),
    ]),
    _c("div", { staticClass: "right", on: { click: _vm.hideMenu } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }